module.exports = {"title":"batch normalization","date":"2017-01-05","layout":"post","path":"/batch_normalization/","category":"nn","description":"batch normalizationまとめのまとめ","body":"<h2>参考</h2>\n<p><a href=\"http://qiita.com/aiskoaskosd/items/59c49f2e2a6d76d62798#4-batch-normalization-accelerating-deep-network-training-by-reducing-internal-covariate-shift\">qiita 2016年の深層学習を用いた画像認識モデル</a></p>\n<h2>まとめ</h2>\n<h3>やっていること</h3>\n<p>チャンネル間の分布の平均と分散を用いて入力値を正規化している\nγc, βcをパラメーターとして学習することで、正規化の際に失われてしまう情報を保持しようとしている。</p>\n<p>chainerではone line</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./articles/batch_normalization/index.md
// module id = 507
// module chunks = 0